import { useEffect, useState } from "react";
import { GLItemStatus, GLItemKind } from "../../../DTO/GLItemDTO";
import { GLItemsDTO } from "../../../DTO/GLItemsDTO";

export default function LogChatAmountDisplay ({
    status,
    kind,
    userId = -1,
    pastduedate = false,
}: {
    status?: GLItemStatus,
    kind?: GLItemKind,
    userId?: number,
    pastduedate?: boolean,
}) {
    const [glitems] = useState(new GLItemsDTO({
        page: 1,
        limit: 1,
        kind,
        status,
        userId,
        pastduedate,
    }))
    const [total, setTotal] = useState(0)
    useEffect(() => {
        console.log('start Log Chat Amount', userId, pastduedate)
        glitems.patchRequest({
            userId,
            pastduedate,
        })
        let intervalId: NodeJS.Timeout;
        setTimeout(() => {
            glitems.getFromServer().then(() => {
                setTotal(glitems.total)
            })
            intervalId = setInterval(() => {
                glitems.getFromServer().then(() => {
                    setTotal(glitems.total)
                })
            }, 30000)
        }, Math.random() * 1000)
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [userId, pastduedate])

    if (total > 0) {
        return <span> ({total})</span>
    }
    return null
}
